const validate = ({ fullname, email, groups }, { dirty, id }) => {
  const errors = {}
  if (!dirty) {
    return errors
  }

  if (!fullname) {
    errors.fullname = 'Display name is required'
  }

  // email is required for user creation
  if (id === 'new' && (!email || !email.toLowerCase().match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/))) {
    errors.email = 'Please provide a valid email address'
  }

  if (!groups) {
    errors.groups = 'Please choose one or more groups for the user'
  }

  return errors
}

export default validate
